import { APIresponse } from"../../../model/client/response";
function numberWithCommas(x: any) {
    return x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

export const MerchantCommissionDetails = (commissions: APIresponse.CommissionDTO) => {
    return (
        <>
                {commissions.value}
        </>
    )
}

export const CommissionModel = (commissions: APIresponse.CommissionDTO) => {
    return (
        <>
            {commissions.commissionModel}
        </>
    )
}

export const MinCap = (commissions: APIresponse.CommissionDTO) => {
    return (
        <>
            {numberWithCommas(commissions.minCap?.toFixed(2))}
        </>
    )
}

export const MaxCap = (commissions: APIresponse.CommissionDTO) => {
    return (
        <>
            {numberWithCommas(commissions.maxCap?.toFixed(2))}
        </>
    )
}

export const ConvenienceFee = (commissions: APIresponse.CommissionDTO) => {
    return (
        <>
            {numberWithCommas(commissions.convenienceFee?.toFixed(2))}
        </>
    )
}
